const SurveyIcon = () => {
  return (
    <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white">
      <path
        d="M29.75 32.5384H22.75L14.9625 37.7183C13.8075 38.4883 12.25 37.6659 12.25 36.2659V32.5384C7 32.5384 3.5 29.0384 3.5 23.7884V13.2883C3.5 8.03827 7 4.53827 12.25 4.53827H29.75C35 4.53827 38.5 8.03827 38.5 13.2883V23.7884C38.5 29.0384 35 32.5384 29.75 32.5384Z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0002 20.1658V19.7983C21.0002 18.6083 21.7352 17.9783 22.4702 17.4708C23.1877 16.9808 23.9051 16.3508 23.9051 15.1958C23.9051 13.5858 22.6102 12.2908 21.0002 12.2908C19.3902 12.2908 18.0952 13.5858 18.0952 15.1958"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20.9921 24.3483H21.0079" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default SurveyIcon
